<div class="checkbox-container" [placement]="tooltipPlacement" [ngbTooltip]="tooltip" [openDelay]="500" (click)="internalClick()" container="body">
    <span class="checkbox" [ngClass]="[size, 'text-' + color]">
        <fa-icon *ngIf="!value" [icon]="['far', 'square']" [ngClass]="{'text-muted': disabled}"></fa-icon>
        <fa-icon *ngIf="value" [icon]="['far', 'check-square']" [ngClass]="{'text-muted': disabled}"></fa-icon>
    </span>
    <div class="checkbox-label">{{label | translate}}</div>
</div>